import { createFileRoute } from '@tanstack/react-router';

import { i18n } from '~/utils';
import { getRouteHead } from '~/utils/routeUtils';

const title = i18n.t(($) => $.form.pageTitle.edit, { ns: 'contract' });

export const Route = createFileRoute(
  '/(main)/demand/contracts/$contractId/edit/items/$itemId/',
)({
  head: () => getRouteHead(title, 'Bearbeite deinen Vertrag in VESTIGAS'),
  staticData: {
    AppBar: {
      title,
    },
  },
});
